// Mock data for GoDrapery clone (frontend-only teaser)
// NOTE: This data is MOCKED. It will be replaced with real backend data later.

export const company = {
  name: "GoDrapery",
  tagline: "Custom Window Coverings in Richmond Hill, ON",
  phone: "416-319-4293",
  phoneHref: "tel:4163194293",
  email: "hello@godrapery.net",
  address: "240 North Lake Road, Richmond Hill, ON, Canada",
  mapsUrl:
    "http://maps.google.com/?q=240%20North%20Lake%20Road,%20Richmond%20Hill,%20ON,%20Canada",
  hours: "Mon – Sat: 9:00 AM – 6:00 PM",
};

export const navLinks = [
  { label: "Home", href: "/#home" },
  { label: "Services", href: "/#services" },
  { label: "Gallery", href: "/#gallery" },
  { label: "Visualizer", href: "/visualizer" },
  { label: "Reviews", href: "/#reviews" },
  { label: "Contact", href: "/#contact" },
];

export const hero = {
  image:
    "https://images.unsplash.com/photo-1754611362309-71297e9f42fd?auto=format&fit=crop&w=1920&q=80",
  eyebrow: "Richmond Hill • Custom Window Coverings",
  title: "Dress Your Windows in Timeless Elegance",
  subtitle:
    "Bespoke draperies, blinds and shades — designed, measured and installed to transform the warmth and style of your home.",
};

export const services = [
  {
    slug: "custom-blinds-consultation",
    title: "Custom Blinds Consultation",
    desc: "Personalized guidance to find blinds that balance light, privacy and style for every room.",
    image:
      "https://images.unsplash.com/photo-1587812226208-37081e8c0ede?auto=format&fit=crop&w=800&q=80",
  },
  {
    slug: "professional-installation",
    title: "Professional Installation",
    desc: "Our expert team fits every covering flawlessly for a polished, seamless finish.",
    image:
      "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=800&q=80",
  },
  {
    slug: "elegant-drapery-selection",
    title: "Elegant Drapery Selection",
    desc: "Luxurious drapes tailored to your taste, from sheer elegance to rich, layered depth.",
    image:
      "https://images.unsplash.com/photo-1628428988931-14bc33099075?auto=format&fit=crop&w=800&q=80",
  },
  {
    slug: "quality-fabric-options",
    title: "Quality Fabric Options",
    desc: "A curated collection of premium, durable fabrics that look stunning and last for years.",
    image:
      "https://images.unsplash.com/photo-1633655442330-0b44ca0cce9b?auto=format&fit=crop&w=800&q=80",
  },
  {
    slug: "free-design-consultation",
    title: "Free Design Consultation",
    desc: "Book a complimentary in-home consultation with a designer who understands your vision.",
    image:
      "https://images.unsplash.com/photo-1714976694531-2288f2708f77?auto=format&fit=crop&w=800&q=80",
  },
];

export const features = [
  {
    icon: "Sparkles",
    title: "Personalized Designs",
    desc: "Every home is unique. We craft coverings that suit your specific style and needs.",
  },
  {
    icon: "Gem",
    title: "Quality Materials",
    desc: "We source only the highest-quality fabrics for beauty that stands the test of time.",
  },
  {
    icon: "Ruler",
    title: "Expert Installation",
    desc: "A dedicated team ensures every window covering is fitted perfectly, hassle-free.",
  },
  {
    icon: "HeartHandshake",
    title: "Exceptional Care",
    desc: "From first consultation to post-install support, your satisfaction is our priority.",
  },
];

export const gallery = [
  {
    src: "https://images.unsplash.com/photo-1688489307301-f6e3b15e01bd?auto=format&fit=crop&w=900&q=80",
    caption: "Layered Living Room Drapes",
  },
  {
    src: "https://images.unsplash.com/photo-1704040686428-7534b262d0d8?auto=format&fit=crop&w=900&q=80",
    caption: "Warm Neutral Curtains",
  },
  {
    src: "https://images.unsplash.com/photo-1628304457639-3dd4ded74a8b?auto=format&fit=crop&w=900&q=80",
    caption: "Serene Bedroom Blinds",
  },
  {
    src: "https://images.unsplash.com/photo-1688506900123-0ae2c0b063a7?auto=format&fit=crop&w=900&q=80",
    caption: "Floor-to-Ceiling Elegance",
  },
  {
    src: "https://images.unsplash.com/photo-1754611362309-71297e9f42fd?auto=format&fit=crop&w=900&q=80",
    caption: "Bright Minimalist Living",
  },
  {
    src: "https://images.unsplash.com/photo-1613685703237-6628de38ddb7?auto=format&fit=crop&w=900&q=80",
    caption: "Soft Filtered Light",
  },
  {
    src: "https://images.unsplash.com/photo-1577926606472-fc6d3a33f7e1?auto=format&fit=crop&w=900&q=80",
    caption: "Modern Sheer Panels",
  },
  {
    src: "https://images.unsplash.com/photo-1704040686510-b747ff423ebb?auto=format&fit=crop&w=900&q=80",
    caption: "Refined Dining Drapes",
  },
  {
    src: "https://images.pexels.com/photos/6980665/pexels-photo-6980665.jpeg?auto=compress&cs=tinysrgb&w=900",
    caption: "Cozy Textured Bedroom",
  },
];

export const testimonials = [
  {
    name: "Sarah L.",
    location: "Richmond Hill, ON",
    rating: 5,
    text: "GoDrapery transformed my living room with their exquisite drapes. The attention to detail is unbeatable!",
  },
  {
    name: "Mark T.",
    location: "Richmond Hill, ON",
    rating: 5,
    text: "The custom blinds I ordered fit perfectly and look amazing. I can't believe the difference they made in my home!",
  },
  {
    name: "Jessica K.",
    location: "Richmond Hill, ON",
    rating: 5,
    text: "Exceptional service from start to finish. I love the quality of my new window coverings and the personal touch.",
  },
];

export const faqs = [
  {
    q: "What types of window coverings do you offer?",
    a: "We provide a wide variety of options including custom blinds, elegant draperies, shades, and shutters, ensuring you find the perfect match for your home's aesthetic.",
  },
  {
    q: "How can I schedule a consultation for window coverings?",
    a: "You can easily schedule a consultation through our website or by calling us directly. We offer personalized appointments to discuss your needs and preferences.",
  },
  {
    q: "Do you provide measurements and installation services?",
    a: "Yes, we offer complete services that include professional measurements and installation to ensure a perfect fit for your new window coverings.",
  },
  {
    q: "Are there eco-friendly options available?",
    a: "Absolutely! We carry a range of eco-friendly window covering materials that provide privacy and style while being kind to the environment.",
  },
  {
    q: "What is the typical turnaround time for an order?",
    a: "Typically, our turnaround time for custom orders ranges from 2 to 4 weeks, depending on the complexity of your selections and current demand.",
  },
];

export const serviceAreas = [
  "Richmond Hill",
  "Markham",
  "Vaughan",
  "Gormley",
  "Whitchurch-Stouffville",
  "Toronto",
  "Almira",
  "King City",
  "Aurora",
  "Bethesda",
];

// Fabrics for the AI Drape Visualizer
export const fabrics = [
  {
    id: "ivory-linen",
    name: "Ivory Linen",
    tone: "Soft, airy neutral",
    swatch:
      "https://images.unsplash.com/photo-1634665810235-011d663754e7?auto=format&fit=crop&w=400&q=80",
    prompt: "soft ivory linen curtains",
  },
  {
    id: "natural-weave",
    name: "Natural Weave",
    tone: "Organic beige texture",
    swatch:
      "https://images.unsplash.com/photo-1588610992315-5654831ceebd?auto=format&fit=crop&w=400&q=80",
    prompt: "natural woven beige linen drapes",
  },
  {
    id: "warm-taupe",
    name: "Warm Taupe",
    tone: "Cozy tan warmth",
    swatch:
      "https://images.unsplash.com/photo-1591195854242-8804547cdcab?auto=format&fit=crop&w=400&q=80",
    prompt: "warm taupe tan velvet curtains",
  },
  {
    id: "champagne-sheer",
    name: "Champagne Sheer",
    tone: "Light-filtering elegance",
    swatch:
      "https://images.unsplash.com/photo-1615799998603-7c6270a45196?auto=format&fit=crop&w=400&q=80",
    prompt: "champagne sheer light-filtering curtains",
  },
  {
    id: "sage-green",
    name: "Sage Green",
    tone: "Calm botanical hue",
    swatch:
      "https://images.unsplash.com/photo-1628428988931-14bc33099075?auto=format&fit=crop&w=400&q=80",
    prompt: "elegant sage green drapery with tassels",
  },
  {
    id: "linen-sample",
    name: "Textured Blend",
    tone: "Refined mixed weave",
    swatch:
      "https://images.unsplash.com/photo-1633655442330-0b44ca0cce9b?auto=format&fit=crop&w=400&q=80",
    prompt: "refined textured blend fabric curtains",
  },
];


// Drapery styles / headings for the visualizer
export const drapeStyles = [
  { id: "Ripplefold", name: "Ripplefold", desc: "Soft, uniform S-wave folds" },
  { id: "French Pleat", name: "French Pleat", desc: "Tailored three-finger pinch" },
  { id: "Pinch Pleat", name: "Pinch Pleat", desc: "Evenly gathered headings" },
  { id: "Goblet Pleat", name: "Goblet Pleat", desc: "Rounded cup-shaped tops" },
  { id: "Inverted Pleat", name: "Inverted Pleat", desc: "Clean flat modern folds" },
  { id: "Roman Shade", name: "Roman Shade", desc: "Soft horizontal folds" },
  { id: "Blinds", name: "Blinds", desc: "Sleek horizontal blinds" },
];
